"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasurementControls = void 0;
const UiElements_1 = require("../../ui/UiElements");
class MeasurementControls {
    constructor(parentEl) {
        if (!parentEl) {
            throw new Error("Parent element (measurement) is undefined");
        }
        const title = this.createTitle();
        const element = this.createElement();
        parentEl.append(title.domEl, element.domEl);
    }
    dispose() {
        delete this.distanceBtn;
        delete this.heightBtn;
        delete this.angleBtn;
        delete this.areaBtn;
        delete this.clearBtn;
    }
    createTitle() {
        return new UiElements_1.DivEl()
            .setClass('module-title')
            .setId('measurementTitle')
            .addAttribute('data-i18n-key', 'MEASUREMENT');
    }
    createElement() {
        this.angleBtn = this.createRadio();
        this.areaBtn = this.createRadio();
        this.distanceBtn = this.createRadio();
        this.heightBtn = this.createRadio();
        this.clearBtn = new UiElements_1.ButtonEl().addAttribute('data-i18n-key', 'RESET');
        const angleLabel = this.createLabelElFor(this.angleBtn, 'ANGLE', 'angle');
        const areaLabel = this.createLabelElFor(this.areaBtn, 'AREA', 'area');
        const distanceLabel = this.createLabelElFor(this.distanceBtn, 'DISTANCE', 'distance');
        const heightLabel = this.createLabelElFor(this.heightBtn, 'HEIGHT', 'height');
        return new UiElements_1.DivEl()
            .setId('measurementControls')
            .setClass('controls')
            .addChild(distanceLabel)
            .addChild(heightLabel)
            .addChild(angleLabel)
            .addChild(areaLabel)
            .addChild(this.clearBtn);
    }
    createRadio(checked = false) {
        const radioEl = new UiElements_1.RadioEl('none', 'measradio');
        if (checked) {
            radioEl.addAttribute('checked', '');
        }
        return radioEl;
    }
    createLabelElFor(radioEl, tooltip, icon) {
        return new UiElements_1.LabelEl('')
            .setClass('icon')
            .addChild(radioEl)
            .addAttribute('data-i18n-attr', `data-title=${tooltip}`)
            .addChild(new UiElements_1.IconEl(icon));
    }
    createButton(id, tooltip, icon) {
        return new UiElements_1.ButtonEl()
            .setId(id)
            .addAttribute('data-i18n-attr', `data-title=${tooltip}`)
            .addChild(new UiElements_1.IconEl(icon));
    }
}
exports.MeasurementControls = MeasurementControls;
